export enum UserSubscriptionStatus {
  TRIAL = 'trial',
  TRIAL_EXPIRED = 'trial_expired',
  SUBSCRIPTION_ACTIVE = 'subscription_active',
}

export interface User {
  id: number;
  email: string;
  name: string;
  isEmailVerified: boolean;
  role: string;
  createdAt: string;
  updatedAt?: string;
  onboarded: boolean;
  subscriptionStatus: UserSubscriptionStatus;
  stripeCustomerId?: string;
  subscription?: {
    id: number;
    subscriptionId: string;
    status: string;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    trialStartDate?: string;
    trialEndDate?: string;
    canceledAt?: string;
    priceId: string;
    commentsPublished: number;
  };
}
